import { Pipe, PipeTransform } from '@angular/core';
/**
 * @description pipe to change the font size of the zero change text
 * seems overkill to use a pipe, but at least it wont pollute compoent's code
 */
@Pipe({
    name: 'zeroChangeFontSize',
    standalone: false
})
export class ZeroChangeFontSizePipe implements PipeTransform {

  transform(value: string): unknown {
    return {
      'free': value.toLowerCase() === 'free'
    };
  }

}
